
import {GetterTree} from 'vuex'
import Mapping from '../ts/MappingInterface';
import RawMapping from '../ts/RawMappingInterface';
import DataVariable from "../../DataVariables/ts/DataVariableInterface";

export const getters: GetterTree<any, any> = {

    /**
     * Get all mapped data variable IDs
     *
     * @param state
     * @param getters
     * @param rootState
     */

    mappedDataVariableIds: (state, getters, rootState) => {
        return state.mappings.map((mapping: Mapping) => {
           return mapping.variable.id;
        });
    },

    /**
     * Get all the column user decided to ignore
     *
     * @param state
     * @param getters
     * @param rootState
     */

    ignoredColumns: (state, getters, rootState) => {
        return state.mappings.filter((mapping: Mapping) => mapping.column.userActions.ignore)
            .map((mapping: Mapping) => mapping.column.index);
    },

    /**
     * Gets all available data variables for given raw types i.e. integer, string
     * while filtering out variable that have already been used in mappings
     *
     * @param state
     * @param getters
     * @param rootState
     */

    dataVariablesAvailable: (state, getters, rootState) => (possibleRawTypes: Array<string>) => {

        let dataVariableTypesPossible: Array<string> = [];

        state.rawMappingTable.forEach((rawMapping: RawMapping) => {
            if (possibleRawTypes.includes(rawMapping.raw)) {
                dataVariableTypesPossible = [...dataVariableTypesPossible, ...rawMapping.variableTypes];
            }
        });

        // Filter possible and remove already mapped data variables
        return rootState.dataVariables.filter( (dataVariable: DataVariable) => {

            if (!dataVariable.create_writable) return false;

            if (dataVariableTypesPossible.includes(dataVariable.type)) {
                if (!getters.mappedDataVariableIds.includes(dataVariable.id) || dataVariable.type==='checkbox') return true;
            }
            return false;
        });
    }
};
